<template>
  <form class="callback__form form" @submit.prevent="sendForm" ref="formCentralized">
    <div class="form__body" v-show="!success">
      <div class="form__items">
        <div class="error_message" v-if="errors['recaptcha']">{{ errors['recaptcha'] }}</div>
        <div class="form__item">
          <div class="default-input" :class="{'error':errors['form_text_1']}">
            <div class="default-input__body" data-sticky-label>
              <input class="default-input__input" type="text" placeholder="Иван Иванов"
                     @input="clearErrors" v-model="form.form_text_1">
              <label class="default-input__label">Имя и фамилия</label>
            </div>
            <div class="default-input__error"><span>{{ errors['form_text_1'] }}</span></div>
          </div>
        </div>
        <div class="form__item">
          <div class="default-input" :class="{'error':errors['form_text_2']}">
            <div class="default-input__body" data-sticky-label>
              <input class="default-input__input" type="text" placeholder="E-mail"
                     @input="clearErrors" v-model="form.form_text_2">
              <label class="default-input__label">E-mail</label>
            </div>
            <div class="default-input__error"><span>{{ errors['form_text_2'] }}</span></div>
          </div>
        </div>

        <div class="form__item">
          <InputSelect label="Тема заявки"
                       :value="form.form_dropdown_APPLICATION_SUBJECT"
          >
            <Multiselect placeholder="Тема заявки"
                         :options="options"
                         no-options-text="Нет доступных вариантов"
                         no-results-text="Нет результатов по вашему запросу"
                         value-prop="id"
                         label="Тема заявки"
                         searchable
                         :model-value="form.form_dropdown_APPLICATION_SUBJECT"
                         @update:model-value="setValue($event)"
            />
          </InputSelect>
        </div>
        <div class="form__item">
          <div class="default-textarea">
            <div class="default-textarea__body">
                      <textarea class="default-textarea__textarea" placeholder="Сообщение" rows="1"
                                @input="clearErrors" v-model="form.form_textarea_6"></textarea>
              <label class="default-textarea__label">Сообщение</label>
            </div>
          </div>
        </div>
        <div class="form__item" v-if="isCareer">
          <InputFile
              placeholder="Прикрепите резюме (.doc, .docx, .pdf, .png, .jpeg)"
              id="file"
              name="form_file_27"
              accept=".doc, .docx, .pdf, .png, .jpeg"
              :model-value="file"
              @update:model-value="setFile($event)"
          ></InputFile>
        </div>
        <div class="form__item" v-if="isCareer">
          <div class="default-input">
            <div class="default-input__body">
              <input class="default-input__input" type="text"
                     placeholder="Или вставьте ссылку на резюме hh.ru" @input="clearErrors"
                     v-model="form.form_text_28">
              <label class="default-input__label">Или вставьте ссылку на резюме hh.ru</label>
            </div>
          </div>
        </div>
      </div>
      <!--      <div style="display: none">-->
      <!--        <vue-recaptcha ref="recaptcha" size="invisible" :sitekey="this.site_key" @verify="sendForm" @expired="onCaptchaExpired"/>-->
      <!--      </div>-->
      <div class="form__submit">
        <button class="form__submit-btn default-btn default-btn--green" type="submit">Отправить
          <svg class="default-btn__icon" aria-hidden="true">
            <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-arrow-right"></use>
          </svg>
        </button>
        <p class="form__policy">Нажимая кнопку, Вы даете <a class="link link--base" :href="agreement"
                                                            target="_blank">информированное
          согласие</a> на обработку своих <a class="link link--base" :href="policy" target="_blank">персональных
          данных</a></p>
      </div>
    </div>

    <div class="form__confirm" v-show="success">
      <p>Спасибо за ваш отклик!</p>
      <p>Мы получили вашу заявку.</p>
    </div>
  </form>
</template>

<script>
import recaptcha from "@/components/mixins/recaptcha";
import errors from "@/components/mixins/errors";
import tools from "@/components/mixins/tools";
import {mapState} from 'vuex'
import InputFile from "@/components/utils/formElements/InputFile.vue";
import InputSelect from "@/components/utils/formElements/InputSelect.vue";
import Multiselect from "@vueform/multiselect"
import {getFileData} from "@/mixins/fileData";

export default {
  name: "FeedBackForm",
  components: {
    InputSelect,
    Multiselect,
    InputFile,
  },
  data() {
    return {
      form: {
        form_text_1: '',
        form_text_2: '',
        form_dropdown_APPLICATION_SUBJECT: '',
        form_textarea_6: '',
        form_file_27: null,
        form_text_28: '',
      },
      application: '',
      errors: {},
      success: false,
      isCareer: false,
      file: null,
    }
  },
  props: {
    agreement: String,
    policy: String,
    code: String,
    subjectName: String,
    subjectId: String,
    landing: String,
    career: String,
    options: Array,
    language: {
      type: [String],
      default: 'ru'
    },
  },
  computed: {
    ...mapState(['moduleWebForm']),
    result() {
      if (this.moduleWebForm.formArray)
        return Object.values(this.moduleWebForm.formArray)
      else
        return []
    },
    isEco: function () {
      return this.landing === 'eco';
    },
    isDobro: function () {
      return this.landing === 'dobro';
    },
  },
  mounted() {
    setTimeout(() => {
      let options = document.querySelectorAll('.multiselect-option');
      for (let i = 0; i < options.length; i++) {
        if (options[i].getAttribute('aria-label') === this.subjectName) {
          options[i].click();
        }
      }

    }, 500);
  },
  mixins: [recaptcha, errors, tools, getFileData],
  methods: {
    sendForm() {
      let formData = new FormData
      formData.set('data', JSON.stringify(this.form))

      let tempData = JSON.parse(formData.get('data'));
      tempData['form_dropdown_APPLICATION_SUBJECT'] = this.application;

      if (this.form.form_dropdown_APPLICATION_SUBJECT) {
        let deps = new Map([
          ['Карьера', 3],
          ['Сотрудничество', 19],
          ['Продажа', 20],
          ['Волонтерство', 24],
          ['Партнерство', 25],
          ['Сдать макулатуру', 26]
        ]);

        tempData['form_dropdown_APPLICATION_SUBJECT'] = deps.get(this.form.form_dropdown_APPLICATION_SUBJECT);
      }

      formData.set('data', JSON.stringify(tempData))
      if(this.file) {
        formData.append('file[0]', this.file[0]);
      }
      formData.append('formCode', this.code)
      formData.append('requiredFields[]', 'form_text_1');
      formData.append('requiredFields[]', 'form_text_2');
      formData.append('language', this.language);

      this.$axios.post('/api/webform/add/',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
      )
          .then((response) => {
            if ('data' in response.data) {
              this.form = {}
              this.success = true
              if (document.querySelector('.default-file__preview span'))
                document.querySelector('.default-file__preview span').click()

              setTimeout(() => {
                this.success = false
              }, 5000)
            } else {
              let message = JSON.parse(response.data.message)
              this.errors = message.errors
              this.application = message.applicationVal

              const targetElement = this.$refs['formCentralized'];
              if (window.locoScroll) {
                window.locoScroll.scrollTo(targetElement, {
                  offset: document.querySelector('.header') ? -(document.querySelector('.header').offsetHeight + 50) : 0,
                })
              } else {
                const yOffset = -100;
                const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
              }
            }
          })
          .catch(() => {
          });
    },
    setValue(eventVal) {
      this.isCareer = eventVal === 'Карьера' ? 'Y' : '';
      this.form.form_dropdown_APPLICATION_SUBJECT = eventVal;
    },
    setFile(file) {
      this.file = file;
    },
    clearErrors() {
      this.errors = {};
    },
  },
  created() {
    this.$store.dispatch('getForm', this.code)
  }
}
</script>
